import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CookieBanner from "@/components/CookieBanner";

/**
 * Main site layout: header + content + footer + cookie banner.
 * Passes an "open cookie preferences" trigger to the footer.
 */
export default function SiteLayout() {
  const [openSignal, setOpenSignal] = useState(0);

  return (
    <div className="min-h-screen flex flex-col bg-slate-950 text-slate-100">
      <Header />
      <main className="flex-1 pt-16">
        <Outlet />
      </main>
      <Footer onOpenCookiePrefs={() => setOpenSignal((v) => v + 1)} />
      <CookieBanner openSignal={openSignal} />
    </div>
  );
}
